import { Link } from "react-router-dom";
import { PageHero } from "../components/PageHero";
import { ServicesGrid } from "../components/ServicesGrid";
import { Reveal } from "../components/Reveal";
import { STEPS } from "../data/content";
import { usePageMeta } from "../hooks/use-page-meta";

export default function Services() {
  usePageMeta(
    "Services | Celebrity Bouncers — Event Security AP & Telangana",
    "Premium event bouncers, VIP movement support, wedding security, concert and corporate event security across Andhra Pradesh and Telangana."
  );
  return (
    <>
      <PageHero
        testid="services-page-hero"
        eyebrow="Premium Services"
        title="Ten Disciplines. One Standard of Composure."
        description="From celebrity movement to parking coordination, every service is scoped, planned and deployed around your event. Select any service to see how we work."
      />
      <section className="container-x py-20 sm:py-28" data-testid="services-page-grid">
        <ServicesGrid />
      </section>
      <section className="border-t border-gold/10 bg-navy/40 py-20 sm:py-28" data-testid="services-page-process">
        <div className="container-x">
          <Reveal>
            <p className="eyebrow">Every Engagement</p>
            <h2 className="mt-4 max-w-3xl font-serif text-3xl font-medium text-ivory sm:text-4xl">
              Scoped. Planned. Positioned. Coordinated. Closed.
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-px bg-white/5 sm:grid-cols-3 lg:grid-cols-5">
            {STEPS.map((s, i) => (
              <Reveal key={s.num} delay={i * 0.07} className="bg-obsidian">
                <div className="p-7">
                  <span className="font-display text-sm tracking-[0.3em] text-gold/60">{s.num}</span>
                  <h3 className="mt-3 font-serif text-lg font-medium text-ivory">{s.title}</h3>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12">
            <Link
              to="/contact"
              data-testid="services-page-enquire-btn"
              className="inline-block bg-gold px-8 py-4 text-[13px] font-bold uppercase tracking-[0.2em] text-obsidian transition-colors duration-300 hover:bg-gold-soft"
            >
              Plan Your Event Security
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
